export class IBaseResponse {
    hasError?: boolean;
    message?: string;
    createdAt?: Date;
    updatedAt?: Date;
}